'use client'

import Link from 'next/link'
import { usePathname } from 'next/navigation'
import { cn } from '@/lib/utils'

import { Button, Logo } from '@/components/ui'
import { Search, Toolbar } from '@/components/molecules'

interface HeaderProps extends React.ComponentPropsWithoutRef<'div'> {}

export const Header = ({ className, ...restProps }: HeaderProps) => {
  const pathname = usePathname()
  const isKot = pathname.startsWith('/kot')
  const isOrderPreview = pathname.startsWith('/order-preview')

  return (
    <header
      className={cn(
        'sticky top-0 z-50 flex h-[var(--header-height)] items-center justify-between bg-gray-50 px-7',
        {
          'lg:bg-white lg:shadow-card': isKot,
        },
        className,
      )}
      {...restProps}
    >
      <div
        className={cn('flex items-center gap-3', {
          'w-full': isKot,
        })}
      >
        <Link href="/">
          <Logo className="h-8" />
        </Link>
      </div>

      <div
        className={cn('flex flex-grow px-3', {
          'lg:w-full': isKot,
        })}
      >
        {!isKot && !isOrderPreview && <Search />}

        {isKot && (
          <div className="mx-auto hidden w-full items-center justify-center gap-2 lg:flex lg:max-w-[500px]">
            <Link href="/kot" className="w-full">
              <Button
                variant={pathname === '/kot' ? 'default' : 'secondary'}
                className="w-full"
              >
                Queued
              </Button>
            </Link>

            <Link href="/kot/prepared" className="w-full">
              <Button
                variant={pathname === '/kot/prepared' ? 'default' : 'secondary'}
                className="w-full"
              >
                Preparing
              </Button>
            </Link>

            <Link href="/kot/ready" className="w-full">
              <Button
                variant={pathname === '/kot/ready' ? 'default' : 'secondary'}
                className="w-full"
              >
                Ready
              </Button>
            </Link>

            <Link href="/kot/completed" className="w-full">
              <Button
                variant={
                  pathname === '/kot/completed' ? 'default' : 'secondary'
                }
                className="w-full"
              >
                Completed
              </Button>
            </Link>
          </div>
        )}
      </div>

      <Toolbar />
    </header>
  )
}
